import { SectionHeader } from "./Products";

const TIERS = [
  {
    name: "Single Court",
    range: "1 – 4 courts",
    discount: "Standard",
    note: "Catalog pricing. Ideal for clubs piloting our hardware.",
    perks: [
      "Standard color options",
      "48h production lead time",
      "Email support",
    ],
    cta: "Request Pricing",
  },
  {
    name: "Facility",
    range: "5 – 24 courts",
    discount: "−15%",
    note: "Most popular for clubs and parks running leagues.",
    perks: [
      "Custom color match",
      "Facility logo emboss",
      "Dedicated account contact",
    ],
    cta: "Request Facility Quote",
    featured: true,
  },
  {
    name: "Network",
    range: "25+ courts",
    discount: "−25%+",
    note: "For municipal departments, multi-site operators and franchises.",
    perks: [
      "Custom SKUs & engineering",
      "Volume scheduled production",
      "Net-30 invoicing available",
    ],
    cta: "Talk to Sales",
  },
];

export default function Pricing() {
  const scrollToQuote = () => {
    document.querySelector("#quote")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="pricing"
      data-testid="pricing-section"
      className="bg-white border-b border-[#E5E5E5]"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16 py-20 md:py-28">
        <SectionHeader
          eyebrow="05 / Volume Pricing"
          title="Pricing scales with your footprint."
          sub="Because we print on demand, larger orders unlock real cost savings — not vague 'enterprise' pricing."
        />

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 border border-[#E5E5E5]">
          {TIERS.map((t, i) => (
            <div
              key={t.name}
              data-testid={`pricing-tier-${t.name.toLowerCase()}`}
              className={`relative p-8 md:p-10 flex flex-col ${
                i < TIERS.length - 1 ? "md:border-r" : ""
              } border-b md:border-b-0 border-[#E5E5E5] ${
                t.featured ? "bg-[#0A0A0A] text-white" : "bg-white"
              } transition-all hover:-translate-y-0.5`}
            >
              {t.featured && (
                <div className="absolute top-0 right-0 bg-[#DFFF00] text-[#0A0A0A] font-mono-bb text-[10px] tracking-widest px-3 py-1.5">
                  MOST POPULAR
                </div>
              )}

              <div className="overline opacity-70">{t.range}</div>
              <h3 className="mt-3 font-display text-3xl md:text-4xl tracking-tight font-medium">
                {t.name}
              </h3>

              <div className="mt-6 flex items-baseline gap-2">
                <span
                  className={`font-display text-4xl font-medium ${
                    t.featured ? "text-[#DFFF00]" : "text-[#0A0A0A]"
                  }`}
                >
                  {t.discount}
                </span>
                <span className="overline opacity-70">vs. catalog</span>
              </div>

              <p
                className={`mt-5 text-[14px] leading-relaxed ${
                  t.featured ? "text-white/75" : "text-[#525252]"
                }`}
              >
                {t.note}
              </p>

              <ul className="mt-7 space-y-3 flex-1">
                {t.perks.map((p) => (
                  <li
                    key={p}
                    className="flex items-start gap-3 text-[14px]"
                  >
                    <i
                      className={`fa-solid fa-square text-[8px] mt-2 ${
                        t.featured ? "text-[#DFFF00]" : "text-[#0A0A0A]"
                      }`}
                    />
                    <span>{p}</span>
                  </li>
                ))}
              </ul>

              <button
                data-testid={`pricing-cta-${t.name.toLowerCase()}`}
                onClick={scrollToQuote}
                className={`mt-10 inline-flex items-center justify-between gap-3 px-5 py-3.5 text-[12px] font-semibold tracking-widest uppercase border transition-colors ${
                  t.featured
                    ? "border-[#DFFF00] bg-[#DFFF00] text-[#0A0A0A] hover:bg-white hover:border-white"
                    : "border-[#0A0A0A] text-[#0A0A0A] hover:bg-[#0A0A0A] hover:text-white"
                }`}
              >
                {t.cta}
                <i className="fa-solid fa-arrow-right text-[11px]" />
              </button>
            </div>
          ))}
        </div>

        <p className="mt-8 font-mono-bb text-[11px] tracking-widest text-[#525252]">
          // ALL TIERS INCLUDE DOMESTIC SHIPPING · NO MINIMUM ORDER QUANTITY ·
          NO SETUP FEES
        </p>
      </div>
    </section>
  );
}
